import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
// import * as JSZip from 'jszip';

import { Const } from '../const';

import { BetweenTimeApiParameter, PastDashboardApiParameter } from '../servicer/models/past-dashboard-api-parameter';
import { BetweenTimeApiResponse, SaveFileApiResponse } from '../servicer/models/dashboard-api-response';

import { VehicleServiceProvider } from '../servicer/vehicle-service';

/**
 * s3パスからzipを取得・解凍し、BetweenTimeApiResponseを返却する
 */
@Injectable()
export class BetweenSaveFileProvider {

    private s3Path: SaveFileApiResponse
    private zip: any

    private testResponce: BetweenTimeApiResponse = {
        target_start_dt: '',
        acutual_start_dt: '',
        target_end_dt: '',
        acutual_end_dt: '',
        time_series: null 
    }

    private readonly EmptyParameter = {
        target_domain_name: '',
        sampling_time: null,
        target_start_dt: '',
        target_end_dt: ''
    } as BetweenTimeApiParameter;

    /** パラメータ情報. */
    public parameter: BehaviorSubject<BetweenTimeApiParameter> = new BehaviorSubject<BetweenTimeApiParameter>(this.EmptyParameter);

    constructor(
        public vehicleService: VehicleServiceProvider,
        public http: HttpClient
    ) { }

    getUnzip(parameter: BetweenTimeApiParameter): BetweenTimeApiResponse{
        let betResponse: BetweenTimeApiResponse
        // /PastDashboardServlet/BetweenTime/SaveFileをたたいてs3パスを取得
        this.getS3Path(parameter)
        // S3との通信処理
        this.zip = this.getZip(this.s3Path.json_gz_url)
        // S3から取得したzipを解凍
        this.unZip(this.zip)
        // 解凍したzipをBetweenTimeApiResponseと同じ形式にしてreturn
        betResponse = this.testResponce
        return betResponse
    }

    private getS3Path(parameter: BetweenTimeApiParameter){
        return this.vehicleService.saveFileRequest(parameter).subscribe(
            res => {
                this.s3Path = res;
            },
            error => {
                console.log('getS3Path error')
            }
        )
    }

    private getZip(url: string){
        // zip取得処理
        return this.http.get(url).subscribe(
            res => {
                return res
            },
            error => {
                console.log('getZip err')
            }
        )
    }

    private unZip(data){
        // zip解凍処理
        // JSZip.loadAsync(data).then(function (zip) {
        //     console.log(data)
        //     console.log(zip)
        // });
        console.log('zip解凍処理')
    }
}


// WEBPACK FOOTER //
// ./src/providers/s3/between-save-file.ts